
export default {
  name: 'ComponentModal',
  props: {
    width: {
      type: String,
      default: '940px',
    },
    height: {
      type: String,
      default: 'calc(100vh - 48px)',
    },
    padding: {
      type: String,
      default: '20px',
    },
    borderRadius: {
      type: String,
      default: '16px',
    },
    minHeight: {
      type: String,
      default: '',
    },
    // Alguns modais (ex: SurveyPopup) precisam de mais altura que os 600px
    // fixos do cap padrão em telas landscape — essa prop permite desligar
    // esse teto e confiar só na prop `height`.
    noLandscapeCap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      return {
        width: this.width,
        height: this.height,
        padding: this.padding,
        borderRadius: this.borderRadius,
        minHeight: this.minHeight,
      }
    },
  },
}
